import {isNil, notEmpty, notNil} from '@megaphonenpm/mputils/src/utils.js';
import {log, warn} from '@megaphonenpm/mputils/src/logfunctions.js';
import {View} from './View.js';
import {CHANGE, DISABLED, SKIPPED, STATE_BOOT} from '@megaphonenpm/mputils/src/constants.js';
import {COMPLETE, FAIL, READY} from '@megaphonenpm/mputils/src/constants.js';
import {TaskManager} from '@megaphonenpm/mputils/src/TaskManager.js';
import {LoadMediaTask} from './LoadMediaTask.js';
import {LoadDeploymentCSSTask} from './LoadDeploymentCSSTask.js';
import {LoadThemesTask} from './LoadThemesTask.js';
import {Simulator} from './Simulator.js';
import {CreateRunViewsTask} from './CreateRunViewsTask.js';
import {Logger} from '@megaphonenpm/mputils/src/Logger.js';
import {ConsoleLogger} from '@megaphonenpm/mputils/src/ConsoleLogger.js';
import {GetRequiredURLParamsTask} from '@megaphonenpm/mputils/src/GetRequiredURLParamsTask.js';
import {GetMRTSRouteTask} from '@megaphonenpm/mrtsclient/src/GetMRTSRouteTask.js';
import {MRTSConnectionTask} from '@megaphonenpm/mrtsclient/src/MRTSConnectionTask.js';
import {MRTSConnection} from '@megaphonenpm/mrtsclient/src/MRTSConnection.js';
import {DataStore} from './DataStore.js';
import {MediaCache} from './MediaCache.js';
import {ApplyDeploymentSettingsTask} from './ApplyDeploymentSettingsTask.js';
import {getScale} from '@megaphonenpm/mputils/src/DOM.js';
import {MRTSConnectionEvent} from '@megaphonenpm/mrtsclient/src/MRTSConnectionEvent.js';
import {ThemeLoader} from './ThemeLoader.js';
import {ProcessThemeSettingsTask} from './ProcessThemeSettingsTask.js';
import {PostMessageManager} from '@megaphonenpm/mputils/src/PostMessageManager.js';
import {ReleaseInfo} from '@megaphonenpm/mputils/src/ReleaseInfo.js';
import {get} from 'lodash-es';
import moment from 'moment/src/moment.js';
import {DebugManager} from './DebugManager.js';
import {screenfull} from '@megaphonenpm/mputils/src/lib/screenfull.js';
import {Mousetrap} from '@megaphonenpm/mputils/src/lib/Mousetrap.js';
import {PostMessageEvent} from '@megaphonenpm/mputils/src/PostMessageEvent.js';
import {PostMessages} from './PostMessages.js';
import {PlaylistService} from '@megaphonenpm/mrtsclient/src/PlaylistService.js';
import {VotesService} from '@megaphonenpm/mrtsclient/src/VotesService.js';
import {SceneService} from '@megaphonenpm/mrtsclient/src/SceneService.js';
import {DeploymentSettingsService} from '@megaphonenpm/mrtsclient/src/DeploymentSettingsService.js';
import {CascadingSettingsService} from '@megaphonenpm/mrtsclient/src/CascadingSettingsService.js';
import {ProductService} from '@megaphonenpm/mrtsclient/src/ProductService.js';
import {CheckMRTSRouteTask} from '@megaphonenpm/mrtsclient/src/CheckMRTSRouteTask.js';
import {Monitor} from '@megaphonenpm/mputils/src/Monitor.js';
import {StartMonitorTask} from '@megaphonenpm/mputils/src/StartMonitorTask.js';
import {WebPollAppStateSynchronizer} from '@megaphonenpm/mrtsclient/src/WebPollAppStateSynchronizer.js';

import {WebPollService} from '@megaphonenpm/mrtsclient/src/WebPollService.js';
import {MRTSClientAppState} from '@megaphonenpm/mrtsclient/src/MRTSClientAppState.js';
import {RefreshWebPollsDataManagerTask} from '@megaphonenpm/mrtsclient/src/RefreshWebPollsDataManagerTask.js';
import {WebPollsDataManager} from '@megaphonenpm/mrtsclient/src/WebPollsDataManager.js';
import {RankingsDataManager} from '@megaphonenpm/mrtsclient/src/RankingsDataManager.js';
import {RefreshRankingsDataManagerTask} from '@megaphonenpm/mrtsclient/src/RefreshRankingsDataManagerTask.js';
import {StartRankingsDataManagerTask} from '@megaphonenpm/mrtsclient/src/StartRankingsDataManagerTask.js';
import {RankingsAppStateSynchronizer} from '@megaphonenpm/mrtsclient/src/RankingsAppStateSynchronizer.js';
import {AudioManager} from './AudioManager.js';
import {LayoutService} from './LayoutService.js';
import {STATE_INTRODUCTION, STATE_SCENE} from '@megaphonenpm/mrtsclient/src/constants.js';
import {AppStateSource} from './AppStateSource.js';
import {InitializeAudioManagerTask} from './InitializeAudioManagerTask.js';
import {OrphanSceneMediaLoader} from './OrphanSceneMediaLoader.js';
import {ThemeService} from '@megaphonenpm/mrtsclient/src/ThemeService.js';
import {AssetStatusHostNotifier} from './AssetStatusHostNotifier.js';
import {ExtensionService} from '@megaphonenpm/mrtsclient/src/ExtensionService.js';

/**
 * Main MegaScreen application entry point.
 */
export class MegaScreen {
  boot () {
    // Preboot setup.
    MegaScreen.globals.releaseInfo = new ReleaseInfo('<@APP_TITLE@>', '<@BUILD_VERSION@>', '<@BUILD_DATE@>');

    let boottime = moment();
    document.querySelector('#splashscreen #appname').textContent = `Megaphone TV ${MegaScreen.globals.releaseInfo.version}`;

    // Create boot manager
    let bootManager = MegaScreen.globals.bootManager = new TaskManager('Boot');

    // Create global app state
    MegaScreen.globals.sceneService = new SceneService();
    MegaScreen.globals.extensionService = new ExtensionService();
    MegaScreen.globals.appState = new MRTSClientAppState(bootManager, MegaScreen.globals.sceneService);
    MegaScreen.globals.appState.state = STATE_BOOT;

    MegaScreen.globals.layoutService = new LayoutService();

    MegaScreen.globals.themeLoader = new ThemeLoader();

    // Handle uncaught errors
    window.addEventListener('error', MegaScreen.globalErrorListener);

    // Create a global Mousetrap instance for handling keyboard input
    MegaScreen.globals.mousetrap = Mousetrap(window, document);

    // Create a global screenfull instance for entering/exiting fullscreen mode
    MegaScreen.globals.screenfull = screenfull(window);

    // Create logger first so all other code in the application can access it
    MegaScreen.globals.logger = Logger.logger();

    // Create debugger
    let debugManager = new DebugManager(boottime, bootManager);
    this.consoleLogger = new ConsoleLogger(MegaScreen.globals.logger);

    // Assign the debugManager's AppState dependency as early as possible so that debugManager
    // has the first opportunity to register for appState.state changes, which allows
    // debugManager to log state changes before any other objects respond to the state change.
    // This preserves expected log-message order.
    debugManager.setAppState(MegaScreen.globals.appState);

    // ID required to check whether the Simulator is ready to handle a "set next scene" post message.
    this.checkSimulatorReadinessTimeoutID = -1;

    // Create global app data store
    MegaScreen.globals.dataStore = new DataStore();

    // Create global Services
    MegaScreen.globals.playlistService = new PlaylistService(MegaScreen.globals.dataStore);
    MegaScreen.globals.votesService = new VotesService();
    MegaScreen.globals.deploymentSettingsService = new DeploymentSettingsService();
    MegaScreen.globals.cascadingSettingsService = new CascadingSettingsService();
    MegaScreen.globals.productService = new ProductService();
    MegaScreen.globals.webpollService = new WebPollService();
    MegaScreen.globals.themeService = new ThemeService(MegaScreen.globals.appState, MegaScreen.globals.dataStore);

    // Create WebPollAppStateSynchronizer (keeps AppState updated with latest Web Poll info)
    this.webPollAppStateSynchronizer = new WebPollAppStateSynchronizer(
      MegaScreen.globals.appState,
      MegaScreen.globals.dataStore,
      MegaScreen.globals.webpollService);

    // Create global MediaCache instance
    MegaScreen.globals.mediaCache = new MediaCache();
    this.assetStatusHostNotifier = new AssetStatusHostNotifier(MegaScreen.globals.mediaCache);

    // Create MRTS connection
    let appStateSourceQueryStringParam = new URLSearchParams(window.location.search).get('appStateSource');
    if (appStateSourceQueryStringParam === AppStateSource.MANUAL) {
      MegaScreen.globals.appStateSource = AppStateSource.MANUAL;
      // MegaScreen is in "manual" mode, so it will ignore state-change assignment attempts by MRTS,
      // and respond solely to manual state changes either via the keyboard or browser post messages.
      // Because MRTS will not be setting the runstate, it must be initialized now
      // (to STATE_INTRODUCTION).
      MegaScreen.globals.appState.runstate = STATE_INTRODUCTION;
      // To allow MegaScreen's MRTSConnection to operate normally, but without affecting MegaScreen's
      // actual application state, supply a "dummy" MRTSClientAppState to MRTSConnection.
      let detachedAppState = new MRTSClientAppState(bootManager, MegaScreen.globals.sceneService);
      MegaScreen.globals.mrtsConnection = new MRTSConnection(detachedAppState, MegaScreen.globals.dataStore);
    } else {
      MegaScreen.globals.appStateSource = AppStateSource.MRTS;
      // MegaScreen is running in the standard mode, where all application state is determined
      // externally by MRTS.
      MegaScreen.globals.mrtsConnection = new MRTSConnection(MegaScreen.globals.appState, MegaScreen.globals.dataStore);
    }

    // Create utility to load scene media for scenes that aren't in the current run's active playlist.
    // See OrphanSceneMediaLoader class documentation for details.
    this.orphanSceneMediaLoader = new OrphanSceneMediaLoader(MegaScreen.globals.mrtsConnection, MegaScreen.globals.mediaCache);

    // Create Web Polls data manager
    MegaScreen.globals.webpollsDataManager = new WebPollsDataManager(MegaScreen.globals.dataStore, this.webPollAppStateSynchronizer);

    // Create Rankings data manager
    MegaScreen.globals.rankingsDataManager = new RankingsDataManager(MegaScreen.globals.dataStore);

    // Create RankingsAppStateSynchronizer (keeps AppState updated with latest external Rankings info)
    this.rankingsAppStateSynchronizer = new RankingsAppStateSynchronizer(
      MegaScreen.globals.appState,
      MegaScreen.globals.dataStore,
      MegaScreen.globals.rankingsDataManager);

    // Create main view
    let view = new View();
    MegaScreen.globals.view = view;

    // Provide DebugManager with access to the app's DebugPanel instance. (This dependency cannot
    // be supplied until after the View has been created.)
    debugManager.setReleaseInfo(MegaScreen.globals.releaseInfo);
    debugManager.setDebugPanel(view.debugPanel);

    // Provide DebugManager with access to the app's MRTSConnection instance. (This dependency cannot
    // be supplied until after the MRTSConnection instance has been created.)
    debugManager.setMRTSConnection(MegaScreen.globals.mrtsConnection);

    // Create MRTS-endpoint monitor
    MegaScreen.globals.mrtsEndpointMonitor = new Monitor(CheckMRTSRouteTask, [MegaScreen.globals.dataStore], 300000, MegaScreen.globals.releaseInfo.title);
    MegaScreen.globals.mrtsEndpointMonitor.on(CHANGE, () => {
      log('MRTS endpoint change detected. Restarting...');
      window.location.reload();
    });
    MegaScreen.globals.mrtsEndpointMonitor.on(SKIPPED, () => {
      log('MRTS endpoint check already in progress. Waiting until current check completes before initiating next check...');

    });
    MegaScreen.globals.mrtsEndpointMonitor.on(DISABLED, () => {
      log(`MRTS endpoint monitoring disabled for ${MegaScreen.globals.mrtsEndpointMonitor.ownerName}.`);
    });

    // Create PostMessageManager and register for incoming post messages
    MegaScreen.globals.postMessageManager = new PostMessageManager();
    MegaScreen.globals.postMessageManager.send(PostMessages.MEGASCREEN_INIT);
    MegaScreen.globals.postMessageManager.on(PostMessageEvent.RECEIVE_MESSAGE, event => {
      let messageName;
      // Incoming postMessages are either simple strings or JSON objects with a .message property.
      // Extract the message name...
      if (notNil(event.detail.message)) {
        if (typeof event.detail.message === 'string') {
          // Example event.detail.message: "CLOSE_DEBUGGER"
          messageName = event.detail.message;
        } else {
          if (event.detail.message.hasOwnProperty('message')) {
            // Example event.detail.message: '{"message": "SET_SCENE_BY_ID", "sceneID": "nnn"}}'
            messageName = event.detail.message.message;
          }
        }
      }

      if (messageName === PostMessages.DISABLE_MRTS_ENDPOINT_MONITORING) {
        MegaScreen.globals.mrtsEndpointMonitor.disable();
      }
      if (messageName === PostMessages.TOGGLE_DEBUGGER) {
        MegaScreen.globals.view.debugPanel.toggleVisibility();
      }
      if (messageName === PostMessages.CLOSE_DEBUGGER) {
        MegaScreen.globals.view.debugPanel.hide();
      }
      if (messageName === PostMessages.SET_STATE) {
        this.processSetStatePostMessage(event.detail.message.stateName, event.detail.message.sceneID);
      }
      if (messageName === PostMessages.TOGGLE_MUTE) {
        if (bootManager.complete) {
          MegaScreen.globals.audioManager.toggleMute();
        }
      }
    });

    // Create audio manager
    MegaScreen.globals.audioManager = new AudioManager(MegaScreen.globals.view);

    // Configure boot tasks
    let requiredParamsMap = new Map();
    requiredParamsMap.set('m', (paramName, paramValue) => {
      MegaScreen.globals.dataStore.megaphoneToken = paramValue;
    });
    requiredParamsMap.set('env', (paramName, paramValue) => {
      MegaScreen.globals.dataStore.environment = paramValue;
    });

    let connectionTasks = [
      new GetRequiredURLParamsTask(requiredParamsMap),
      new GetMRTSRouteTask(MegaScreen.globals.dataStore),
      new StartMonitorTask('START_MRTS_ENDPOINT_MONITOR', MegaScreen.globals.mrtsEndpointMonitor),
      new MRTSConnectionTask(MegaScreen.globals.mrtsConnection)
    ];
    let contentTasks = [
      new LoadDeploymentCSSTask(),
      new RefreshWebPollsDataManagerTask(MegaScreen.globals.webpollsDataManager),
      new LoadMediaTask(),
      new LoadThemesTask(),
      new CreateRunViewsTask(),
      new ApplyDeploymentSettingsTask(),
      new RefreshRankingsDataManagerTask(MegaScreen.globals.rankingsDataManager),
      new StartRankingsDataManagerTask(MegaScreen.globals.rankingsDataManager),
      new InitializeAudioManagerTask(MegaScreen.globals.audioManager)
    ];

    let contentTaskManager = new TaskManager('ContentManager');
    contentTaskManager.addTasks(contentTasks);

    MegaScreen.globals.mrtsConnection.on(MRTSConnectionEvent.CONTENT_READY, () => {
      if (bootManager.complete) {
        MegaScreen.globals.rankingsDataManager.stop();

        // When the MRTS playlist is updated after MegaScreen has already booted, load any
        // web polls, rankings, and media referenced by the playlist's scenes
        let updateContentTaskManager = new TaskManager('UpdateContent');
        updateContentTaskManager.addTasks([
          new RefreshWebPollsDataManagerTask(MegaScreen.globals.webpollsDataManager),
          new RefreshRankingsDataManagerTask(MegaScreen.globals.rankingsDataManager),
          new StartRankingsDataManagerTask(MegaScreen.globals.rankingsDataManager),
          new LoadMediaTask()
        ]);
        updateContentTaskManager.start();
      }
      let processThemeSettingsTask = new ProcessThemeSettingsTask();
      processThemeSettingsTask.start();
    });

    // Configure boot sequence
    log(`Starting ${MegaScreen.globals.releaseInfo.title} ${MegaScreen.globals.releaseInfo.version}...`);
    log(`Build date: ${MegaScreen.globals.releaseInfo.date}`);
    log(`App State Source: ` + MegaScreen.globals.appStateSource);
    bootManager.on(COMPLETE, e => {
      // Provide a state "simulator" for controlling MegaScreen's application state via manual
      // inputs such as the keyboard or an external application such as Director.
      MegaScreen.globals.simulator = new Simulator();
      // Inform parent page (Director) that the boot process has completed.
      MegaScreen.globals.postMessageManager.send(PostMessages.MEGASCREEN_BOOT_COMPLETE);
      byeNeo();
    });
    bootManager.on(FAIL, e => {
      let failureMessage = get(e, 'detail.error.message');
      MegaScreen.globals.logger.fatal(`Boot failed at task: ${e.detail.name}.`
        + (isNil(failureMessage) ? '' : ` ${failureMessage}.`));
    });
    bootManager.addTasks(connectionTasks);
    bootManager.addTasks(contentTaskManager);

    // Boot application
    bootManager.start();
  }

  processSetStatePostMessage (stateName, sceneID) {
    // If there's a Simulator-readiness check pending already, clear it now (and schedule a new one
    // if the Simulator isn't ready yet).
    clearTimeout(this.checkSimulatorReadinessTimeoutID);

    if (MegaScreen.globals.appStateSource === AppStateSource.MANUAL) {
      let ready = false;

      if (notNil(MegaScreen.globals.simulator)) {
        if (stateName === STATE_SCENE) {
          // If the playlist in this MegaScreen instance doesn't contain the specified scene, the
          // MRTS playlist was probably updated, but this MegaScreen instance hasn't received it yet
          // (i.e., MRTSConnectionEvent.CONTENT_READY has not yet been received). In that case,
          // check back for the existence of the scene later.
          if (notNil(MegaScreen.globals.playlistService.getSceneByID(sceneID))) {
            ready = true;
            MegaScreen.globals.simulator.gotoScene(sceneID);
          }
        } else {
          MegaScreen.globals.simulator.gotoState(stateName);
          ready = true;
        }
      }

      if (!ready) {
        this.checkSimulatorReadinessTimeoutID = setTimeout( () => {
          this.processSetStatePostMessage(stateName, sceneID);
        }, 500);
      }
    }
  }
}

MegaScreen.globalErrorListener = (e) => {
  warn(`UNCAUGHT ERROR: ${e.message}
  ${e.filename} Line ${e.lineno}, Col ${e.colno}`);
};

MegaScreen.globals = {};

// The application's official name, as it appears in the UI and logs.
MegaScreen.globals.APP_TITLE = 'MegaScreen';

MegaScreen.globals.getGlobalScale = () => {
  return getScale(document.querySelector('.applicationRoot'));
};

const megascreen = new MegaScreen();
megascreen.boot();
